/**
 * What a rescheduled task's new due date must satisfy, or the reason it does
 * not (null when it does). Calendar days, `YYYY-MM-DD`.
 *
 * Mirrors the server's `dueDateProblem` (cgt-backend equipment/overdue.ts),
 * which enforces the same: a changed due date is today or later (moving an
 * overdue task's date is how it is put back on schedule) and never before the
 * task's early start. Checked here first so the cell can say why before saving.
 */
export function dueDateProblem(input: {
  today: string
  dueDate: string
  /** The due date saved now; an unchanged one is not checked against today. */
  current: string
  earlyStart: string | null | undefined
}): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(input.dueDate)) return 'Enter a date.'
  if (input.dueDate !== input.current && input.dueDate < input.today) {
    return 'The due date cannot be in the past.'
  }
  if (input.earlyStart && input.dueDate < input.earlyStart) {
    return 'The due date cannot be before the early start.'
  }
  return null
}

/** The earliest due date the picker offers: today, or the early start if later. */
export function earliestDueDate(today: string, earlyStart: string | null | undefined): string {
  return earlyStart && earlyStart > today ? earlyStart : today
}
